import Axios from 'axios'
import server from 'util/Server'
import Servidor from 'util/Servidor';

export const getDataDominio = async (dCompleto) => {
    dCompleto = window.location.host.includes('localhost') ? Servidor.hostEntrada : dCompleto
    console.log("::: Loading Dominio :::", dCompleto)
    console.log("::: Kardex :::")
    return new Promise(function (resolve, _reject) {
        const n = server.host + server.puertoApp;
        Axios.post(n + '/api/v1/domain', { "dominio": dCompleto })
            .then(response => {
                if (response.status === 200) {
                    resolve(response.data.data)
                }
            })
            .catch(function (error) {
                console.log(error)
                resolve(error)
            })
    })
}
